import React from "react";
import { CustomHeader } from 'react-calendar-timeline' // new

/**
 * Displays the week on the top of the header ontop of the gant chart. The header changes itself based upon the size of the screen.
 * @param {*} param0 
 */
const CustomDateHeader = ({ unit, textAlign, widescreen }) => {
  return (
  <CustomHeader unit={unit}>
    {({
      headerContext: { intervals },
      getRootProps,
      getIntervalProps,
      showPeriod
    }) => {
      return (
        <div {...getRootProps({ style: { height: 30, fontSize: 14 } })}>
          {intervals.map(interval => {
            const intervalStyle = {
              // height: 30,
              lineHeight: '30px',
              textAlign: textAlign,
              border: '0.5px solid gray',
              // cursor: 'pointer',
              // backgroundColor: 'initial',
              // color: 'white'
            }
            return (
              <div
                // onClick={() => {
                //   showPeriod(interval.startTime, interval.endTime)
                // }}
                {...getIntervalProps({
                  interval,
                  style: intervalStyle
                })}
              >
                <div className="sticky react-calendar-timeline rct-dateHeader-primary">
                  {widescreen ? interval.startTime.format('MMM, YYYY') : null}
                </div>
              </div>
            )
          })}
        </div>
      )
    }}
</CustomHeader>

  );
}

export default CustomDateHeader;
